import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import InfoModal from "src/components/Modal/Info";
import React from "react";
import { faLock, faLockOpen } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";

const StayAccessDialog = ({ stay, handleClose }) => {
  const { t } = useTranslation("dashboard");

  return (
    <InfoModal
      show={true}
      title={t("booking_details.access_dialog.title")}
      handleClose={handleClose}
    >
      <div>
        <span>{t("booking_details.access_dialog.drive_in.label")}:&nbsp;</span>
        {stay.can_drive_in ? (
          <FontAwesomeIcon icon={faLockOpen} className={"text-success"} />
        ) : (
          <>
            <FontAwesomeIcon icon={faLock} className={"text-danger"} />
            <ul>
              {stay.can_drive_in_errors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </>
        )}
      </div>
      <div>
        <span>{t("booking_details.access_dialog.drive_out.label")}:&nbsp;</span>
        {stay.can_drive_out ? (
          <FontAwesomeIcon icon={faLockOpen} className={"text-success"} />
        ) : (
          <>
            <FontAwesomeIcon icon={faLock} className={"text-danger"} />
            <ul>
              {stay.can_drive_out_errors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </>
        )}
      </div>
      <div>
        <span>{t("booking_details.access_dialog.checkout.label")}:&nbsp;</span>
        {stay.can_checkout ? (
          <FontAwesomeIcon icon={faLockOpen} className={"text-success"} />
        ) : (
          <>
            <FontAwesomeIcon icon={faLock} className={"text-danger"} />
            <ul>
              {stay.can_checkout_errors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          </>
        )}
      </div>
    </InfoModal>
  );
};

export default StayAccessDialog;
